import homeReducer from "./homeReducer";
import leftMenuReducer from "./leftMenuReducer";
import loginReducer from "./loginReducer";
import {aboutMeReducer} from "./AboutMeReducer";
import {vacationReducer} from "./vacationReducer";
import {dayOffReducer} from "./dayOffReducer";
import {matHelpReducer} from "./matHelpReducer";
import {accessMatrixReducer} from "./accessMatrixReducer";
import workDocumentsReducer, {workDocumentsItems} from "./workDocumentsReducer";
import privateDocumentsReducer from "./privateDocumentsReducer";
import {paySlipReducer} from "./paySlipReducer";
import {subVacationReducer} from "./subVacationReducer";
import {subEducationReducer} from "./subEducationReducer";
import {subMedicalPolicyReducer} from "./subMedicalPolicyReducer";
import {subOfficialDocumentsReducer} from "./subOfficialDocumentsReducer";
import {subDayOffReducer} from "./subDayOffReducer";
import {personalStageReducer} from "./personalStageReducer";
import {subAccessMatrixReducer} from "./subAccessMatrixReducer";
import {dailyChartReducer} from "./dailyChartReducer";
import {subScheduleReducer} from "./subScheduleReducer";
import {workingHoursReducer} from "./workingHoursReducer";
import {subScheduleChangeReducer} from "./subScheduleChangeReducer";
import {confidentialInformationReducer} from "./confidentialInformationReducer";
import {peopleBoardReducer} from "./peopleBoardReducer";
import {smsAuthReducer} from "./smsAuthReducer";
import {rvdReducer} from "./rvdReducer";
import {docflowReducer} from "./docflowReducer";
import {claimReducer} from "./claimReducer";
import {acquaitanceReducer} from "./acquaitanceReducer";
import {selfServiceReducer} from "./selfServiceReducer";
import {yearBonusReducer} from "./yearBonusReducer";
import {subBenefitsReducer} from "./subBenefitsReducer";
import {orgChartReducer} from "./orgChartReducer";
import {referencesReducer} from "./referencesReducer";
import {subPositionResponsibilitiesReducer} from "./subPositionResponsibilitiesReducer";
import soutReducer from "./soutReducer";
import {annualRemunerationReducer} from "./annualRemunerationReducer";
import {instructionReducer} from "./instructionReducer";
import {salaryProjectReducer} from "./salaryProjectReducer";
import {subFinanceEmailItems, subFinanceEmailReducer} from "./subFinanceEmailReducer";
import {signTimeSheetReducer} from './signTimeSheetReducer';
import {subRemoteWorkReducer} from "./subRemoteWorkReducer";

const rootReducer = {
    appState: homeReducer, leftMenuReducer, loginState: loginReducer,
    aboutMeState: aboutMeReducer(),
    vacationState: vacationReducer(),
    dayOffState: dayOffReducer(),
    matHelpState: matHelpReducer(),
    accessMatrixState: accessMatrixReducer(),
    workDocumentsState: workDocumentsReducer,
    workDocumentsItems: workDocumentsItems(),
    privateDocumentsState: privateDocumentsReducer(),
    paySlipState: paySlipReducer(),
    personalStageState: personalStageReducer(),
    subVacationState: subVacationReducer(),
    subEducationState: subEducationReducer(),
    subMedicalPolicyState: subMedicalPolicyReducer(),
    subOfficialDocumentsState: subOfficialDocumentsReducer(),
    subDayOffState: subDayOffReducer(),
    subAccessMatrixState: subAccessMatrixReducer(),
    dailyChartState: dailyChartReducer(),
    subScheduleState: subScheduleReducer(),
    workingHoursState: workingHoursReducer(),
    subScheduleChangeState: subScheduleChangeReducer(),
    confidentialInformationState: confidentialInformationReducer(),
    peopleBoardState: peopleBoardReducer(),
    smsAuthState: smsAuthReducer(),
    rvdState: rvdReducer(),
    docflowState: docflowReducer(),
    claimState: claimReducer(),
    acquaitanceState: acquaitanceReducer(),
    selfServiceState: selfServiceReducer(),
    yearBonusState: yearBonusReducer(),
    subBenefitsState: subBenefitsReducer(),
    orgChartState: orgChartReducer(),
    referencesState: referencesReducer(),
    subPositionResponsibilitiesState: subPositionResponsibilitiesReducer(),
    soutState: soutReducer(),
    annualRemunerationReducer: annualRemunerationReducer(),
    instructionState: instructionReducer(),
    salaryProjectState: salaryProjectReducer(),
    subFinanceEmailItems: subFinanceEmailItems(),
    subFinanceEmailState: subFinanceEmailReducer,
    signTimeSheetState: signTimeSheetReducer(),
    subRemoteWorkState: subRemoteWorkReducer()
};

export default rootReducer;